export const ERRORS = Object.freeze({
  AUTH_TOO_MANY_ATTEMPTS:
    'Забагато неправильних спроб. Будь ласка, спробуйте пізніше.',
  AUTH_NO_USER:
    'Користувача не знайдено. Будь ласка, перевірте правильність написання пошти.',
  AUTH_NO_USER_TRY_REGISTER:
    'Користувача не знайдено. Будь ласка, перевірте правильність написання пошти. Або створіть акаунт.',
  AUTH_INVALID_OPT:
    'Код невірний. Будь ласка, перевірте правильність введення.',
  AUTH_OTP_EXPIRED: 'Термін дії коду закінчився.'
})
